import { createSlice } from '@reduxjs/toolkit'
import { SecurityGroupsServerData } from '@lk/api'

import { loadSecurityUserGroups } from './groups.actions'

export interface SecurityGroupsState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  list: SecurityGroupsServerData
}

const initialState: SecurityGroupsState = {
  status: 'idle',
  error: null,
  list: [],
}

export const securityGroupsReducer = createSlice({
  name: 'securityUsers',
  initialState,
  reducers: {},
  extraReducers: {
    [loadSecurityUserGroups.pending.toString()]: (state) => {
      state.status = 'loading'
      state.list = []
    },
    [loadSecurityUserGroups.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.list = action.payload
    },
    [loadSecurityUserGroups.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
      state.list = []
    },
  },
}).reducer
